import { useCallback, useEffect } from 'react'
import useFlowStore from '../../../components/chatflow/store'

/**
 * useContextMenu — Manages the canvas context menu.
 *
 * Responsibilities:
 * - Open the menu on right-click on a node or on the canvas
 * - Auto-close on window scroll or resize
 */
export function useContextMenu() {
  const contextMenu     = useFlowStore((s) => s.contextMenu)
  const setContextMenu  = useFlowStore((s) => s.setContextMenu)
  const setSelectedNode = useFlowStore((s) => s.setSelectedNode)

  /* Auto-closes the menu on scroll or resize */
  useEffect(() => {
    if (!contextMenu) return
    const close = () => setContextMenu(null)
    window.addEventListener('scroll', close, true)
    window.addEventListener('resize', close)
    return () => {
      window.removeEventListener('scroll', close, true)
      window.removeEventListener('resize', close)
    }
  }, [contextMenu, setContextMenu])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onNodeContextMenu = useCallback((e: React.MouseEvent, node: any) => {
    if (node.type === 'trigger') return
    e.preventDefault()
    setContextMenu({ x: e.clientX, y: e.clientY, node })
    setSelectedNode(node)
  }, [setContextMenu, setSelectedNode])

  const onPaneContextMenu = useCallback((e: React.MouseEvent | MouseEvent) => {
    e.preventDefault()
    setContextMenu({ x: (e as MouseEvent).clientX, y: (e as MouseEvent).clientY, node: null })
  }, [setContextMenu])

  return { onNodeContextMenu, onPaneContextMenu }
}
